// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    refineByStyle: "style2",
    filterTreeMobileStyle: "style1",
  },
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;

// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  productGridItemHtml:
    '<div data-product-handle={{itemHandle}} id="{{itemHandle}}" class="grid__item grid-product ' +
    boostPFSConfig.custom.grid_item_width +
    ' {{itemQuickShopClass}}" data-aos="row-of-' +
    boostPFSConfig.custom.products_per_row +
    '">' +
    '<div class="grid-product__content">' +
    "{{itemLabel}}" +
    '<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
    '<div class="grid-product__image-mask">' +
    '<div class="grid-product__btn-wrapper">' +
    `{{itemSampleButton}}` +
    "{{itemQuickShopButton}}" +
    "</div>" +
    "{{itemImages}}" +
    "{{itemSwatchHoverImages}}" +
    "</div>" +
    '<div class="grid-product__meta">' +
    '<div class="grid-product__title">{{itemTitle}}</div>' +
    "{{itemVendor}}" +
    '<div class="grid-product__price">{{itemPrice}}</div>' +
    "{{reviewHtml}}" +
    "</div>" +
    "</a>" +
    "</div>" +
    "{{itemSwatch}}" +
    "</div>",

  // Pagination Template
  previousActiveHtml: '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
  previousDisabledHtml: "",
  nextActiveHtml: '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
  nextDisabledHtml: "",
  pageItemHtml: '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
  pageItemSelectedHtml: '<span class="page current">{{itemTitle}}</span>',
  pageItemRemainHtml: '<span class="deco">...</span>',
  paginateHtml: "{{previous}}{{pageItems}}{{next}}",

  // Sorting Template
  sortingHtml:
    '<label for="boost-pfs-filter-top-sorting-select" class="hidden-label">' +
    boostPFSConfig.label.sorting +
    '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    var isCustomWallpaper = data.product_type === "Custom Wallpaper";

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Get the product from the object stored on window (collection.liquid, search.liquid) that contains the products with veriant metafield information
    var productWithVariantMetafields = window.collectionProductsWithVariantMetafields[data.id];
    if (productWithVariantMetafields) {
      $.each(data.variants, function (index, item) {
        // Add the metafields to the variants on the data object that we'll continue to reference in this funciton
        // This will help us check for color matches that aren't apparent in the option_color text
        var variantMetafields = productWithVariantMetafields.variants[item.id].metafields;
        data.variants[index].metafields = variantMetafields;
      });
    }

    // Collection metafield adds a color to the page if the collection requires
    // a certain color to be selected for all products
    var colorCollection = jQ("[data-color-collection]").attr("data-color-collection");
    // Check query string to see if the results are filtered
    var hasColorFilterQueryParam = Globals.queryParams.hasOwnProperty("pf_t_color");

    if (colorCollection) {
      colorCollection = colorCollection.split("|");
    }

    if (hasColorFilterQueryParam || colorCollection) {
      var selectedColors = Globals.queryParams.pf_t_color || colorCollection;
      var matchingVariants = []

      for (var k = 0; k < selectedColors.length; k++) {
        var selectedColor = selectedColors[k].toLowerCase().replace("color_", "");

        // Take the current color filter and find a match in the variant's option_color or metafields.color
        var matchingVariant = $.grep(data.variants, function (item, index) {
          var isSampleVariant = item.title.toLowerCase().includes("sample");
          if(isSampleVariant) { return false; }

          var matchesColorOption = item.option_color ? item.option_color.toLowerCase().includes(selectedColor) : false;
          var matchesColorMetafield = item.metafields ? item.metafields.color.toLowerCase().includes(selectedColor) : false;

          return (matchesColorOption || matchesColorMetafield);
        });
        // Merge any matches into the matchingVariants array
        $.merge(matchingVariants, matchingVariant);
      }
    }

    // Check query string to see if the results are filtered
    var hasMaterialFilterQueryParam = Globals.queryParams.hasOwnProperty("pf_opt_material");
    
    var materialCollection = jQ("[data-material-collection]").attr("data-material-collection");
    
    if (materialCollection) {
      materialCollection = [jQ("[data-material-collection]").attr("data-material-collection")];
    }

    
    data.sample_button_data = getSampleButtonData(data);
    
    if (hasMaterialFilterQueryParam || materialCollection) {
      var selectedMaterials = Globals.queryParams.pf_opt_material || materialCollection;
      var matchingVariants = [];
      
      for (var k = 0; k < selectedMaterials.length; k++) {
        var selectedMaterial = selectedMaterials[k].toLowerCase();
        // Take the current color filter and find a match in the variant's option_color or metafields.color
        var matchingVariant = $.grep(data.variants, function (item, index) {
          var isSampleVariant = item.title.toLowerCase().includes("sample");
          if(isSampleVariant) { return false; }

          var matchesMaterialOption = item.option_material ? item.option_material.toLowerCase().includes(selectedMaterial) : false;

          return (matchesMaterialOption);
        });
        // Merge any matches into the matchingVariants array
        $.merge(matchingVariants, matchingVariant);
      }
      // Set sample button data on the data object for easier swatch/sample button updating
      data.sample_button_data = getCustomSampleButtonData(matchingVariant);
    }

    // Add current_variant_index to the data object
    // Set it to the variant that matches the filters if it exists, otherwise use the first variant
    data.current_variant_index = (Array.isArray(matchingVariants) && matchingVariants.length) ? data.variants.indexOf(matchingVariants[0]) : 0;

    // Set the thumbnail URL to the filtered product variant if there's a match
    // Otherwise, set it to the first image
    var itemThumbUrl = images.length > 0 ? data.variants[data.current_variant_index].image : boostPFSConfig.general.no_image_url

    var imgIndex = images.length > 0 ? 0 : -1;
    for (var i = 0; i < images.length; i++) {
      if (itemThumbUrl == images[i].src) {
        imgIndex = i;
        break;
      }
    }

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]["width"] / images[0]["height"] : "";
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : "100";
    var thumb = images.length > 0 ? images[imgIndex] : boostPFSConfig.general.no_image_url;
    var thumbSrc = images.length > 0 ? images[imgIndex].src : boostPFSConfig.general.no_image_url;
    var bgset = buildBgSet(thumb);
    var itemImagesHtml = "";

    if (boostPFSConfig.custom.product_grid_image_size == "natural") {
      itemImagesHtml +=
        '<div class="image-wrap" style="height: 0; padding-bottom: ' +
        paddingBottom +
        '%;">' +
        "<img " +
        'class="grid-product__image lazyload" ' +
        'data-src="' +
        // From the upgrade file, this Utils function might be useful?
        // Utils.getFeaturedImage(images, "{width}x") +
        thumbSrc +
        '" ' +
        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">' +
        "</div>";
    } else {
      itemImagesHtml +=
        "<div " +
        'class="grid__image-ratio grid__image-ratio--' +
        boostPFSConfig.custom.product_grid_image_size +
        ' lazyload"' +
        'data-bgset="' +
        bgset +
        '"' +
        'data-sizes="auto">' +
        "</div>";
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        bgset = buildBgSet(images[imgIndex + 1])
          ? buildBgSet(images[imgIndex + 1])
          : buildBgSet(images[imgIndex]);
        itemImagesHtml +=
          "<div " +
          'class="grid-product__secondary-image small--hide lazyload"' +
          'data-bgset="' +
          bgset +
          '"' +
          'data-sizes="auto">' +
          "</div>";
      }
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = "";

    // HC - 15 Feb '22 - added wrapper for none sale price
    if (!onSale) {
      itemPriceHtml +=
        '<span class="hc-normal-price-wrapper">';
    }
    
    if (priceVaries) {
      itemPriceHtml +=
        '<span class="grid-product__from body-small">from</span> ';
    }

    if (onSale) {
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.regular_price +
        "</span>";
      itemPriceHtml +=
        '<span class="grid-product__price--original">' +
        Utils.formatMoney(data.compare_at_price_min) +
        "</span>";
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.sale_price +
        "</span>";
    }
    if (priceVaries) {
      var priceMarkup = Utils.formatMoney(minPriceWithoutSample(data));
      itemPriceHtml += onSale
        ? '<span class="grid-product__price--sale">' + priceMarkup + "</span>"
        : priceMarkup;
    } else {
      itemPriceHtml += Utils.formatMoney(minPriceWithoutSample(data));
    }

    // HC - 15 Feb '22 - added wrapper for none sale price
    if (!onSale) {
      itemPriceHtml +=
        '</span>';
    }
    
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = "";
      if (boostPFSConfig.custom.product_save_type == "dollar") {
        savePrice = Utils.formatMoney(
          data.compare_at_price_min - minPriceWithoutSample(data)
        );
      } else {
        savePrice = Math.round(
          ((data.compare_at_price_min - minPriceWithoutSample(data)) * 100) /
          data.compare_at_price_min
        );
        savePrice += "%";
      }
      // var savePriceText = boostPFSConfig.label.save_html.replace(
      //   /{{ saved_amount }}/g,
      //   savePrice
      // )
      // itemPriceHtml +=
      //   '<span class="grid-product__price--savings">' +
      //   savePriceText +
      //   "</span>"
    }

    // Custom products show no price
    if (isCustomWallpaper) {
      itemPriceHtml =
        '<span class="grid-product__price__custom overline">Custom</span>';
    }

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? "grid-product__link--disabled" : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = "";
    data.tags.forEach(function (tag) {
      if (tag.startsWith("_label_")) {
        if (!customLabel) {
          customLabel = tag.replace("_label_", "");
        }
      }
    });
    var itemLabelHtml = "";
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + "</div>";
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + "</div>";
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + "</div>" : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add sample button
    var itemSampleButtonHtml = "";
    if (data.sample_button_data) {
      var currentVariantColor = data.variants[data.current_variant_index].option_color;
      var currentVariantColorSlug = Utils.slugify(currentVariantColor);
      if (Object.keys(data.sample_button_data).includes(currentVariantColorSlug)) {
        var activeSample = data.sample_button_data[currentVariantColorSlug][0];
        itemSampleButtonHtml = '<div class="sample-btn" data-order-sample="' + activeSample.id + '">+ Order a sample</div>';
      }
      // var hasTwoMaterials = data.sample_button_data[currentVariantColorSlug].length

      // itemSampleButtonHtml = '<div class="sample-btn" data-order-sample="' + firstSample.id + '">+ ' + firstSample.material + ' sample</div>'

    }
    itemHtml = itemHtml.replace(/{{itemSampleButton}}/g, itemSampleButtonHtml);

    // Add Quick shop
    var itemQuickShopClass = "";
    var itemQuickShopButtonHtml = "";
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = "grid-product__has-quick-shop";
      itemQuickShopButtonHtml =
        `<div class="quick-product__btn ${isCustomWallpaper ? " is-custom-wallpaper" : ""
        } js-modal-open-quick-modal-{{itemId}} small--hide ` +
        (isFirstLoad ? "" : "bc-hide") +
        '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' +
        boostPFSConfig.label.quick_shop +
        "</span>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(
      /{{itemQuickShopButton}}/g,
      itemQuickShopButtonHtml
    );

    // Review
    var reviewHtml = "";
    if (boostPFSConfig.custom.enable_product_reviews) {
      reviewHtml = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>';
    }
    itemHtml = itemHtml.replace(/{{reviewHtml}}/g, reviewHtml);

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(
      /{{itemSwatchHoverImages}}/g,
      swatchHtml.itemSwatchHoverImages
    );

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    //itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data))

    var itemUrlHtml = Utils.buildProductItemUrl(data);
    var productUrl = Utils.buildProductItemUrl(data);
    // If the current variant is the first one, use the product URL as-is
    // But link to a specific variant if a different one is active
    var currentVariantId = data.variants[data.current_variant_index].id
    var itemUrlHtml = data.current_variant_index <= 0 ? productUrl : productUrl + "?variant=" + currentVariantId

    itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrlHtml);

    return itemHtml;
  };

  function minPriceWithoutSample(product) {
    var variants = product.variants;
    var isWallpaper = product.product_type.toLowerCase() === "wallpaper";
    var price_min = 0;

    for (var i = 0; i < variants.length; i++) {
      if (i == 0) {
        price_min = variants[i].price;
      } else if (isWallpaper) {
        // If it's wallpaper, check the size to exclude samples
        if (!variants[i].option_size.toLowerCase().includes("sample")) {
          if (price_min > variants[i].price) {
            price_min = variants[i].price;
          }
        }
      } else {
        if (price_min > variants[i].price) {
          price_min = variants[i].price;
        }
      }
    }

    return price_min;
  }

  // Either returns a product's Sample IDs organized by type and color or false if none exist
  function getSampleButtonData(product) {
    var productSamples = getProductSamples(product);
    var sampleData = {};
    // console.log('productSamples', productSamples)

    if (!productSamples.length) {
      return false;
    }

    productSamples.map(function (sample, index) {
      var colorValueSlugify = Utils.slugify(sample.option_color);
      var item = {
        material: sample.option_material,
        id: sample.id,
      };
      if (!sampleData[colorValueSlugify]) {
        sampleData[colorValueSlugify] = [item];
      } else {
        sampleData[colorValueSlugify].push(item);
      }
    });

    // console.log('sampleData', sampleData)

    return sampleData;
  }

  // Either returns a product's Sample IDs organized by type and color or false if none exist
  function getCustomSampleButtonData(variants) {
    var sampleData = {};
    // console.log('productSamples', productSamples)

    variants.map(function (sample, index) {
      var colorValueSlugify = Utils.slugify(sample.option_color);
      var item = {
        material: sample.option_material,
        id: sample.id,
      };
      if (!sampleData[colorValueSlugify]) {
        sampleData[colorValueSlugify] = [item];
      } else {
        sampleData[colorValueSlugify].push(item);
      }
    });

    // console.log('sampleData', sampleData)

    return sampleData;
  }

  function getProductSamples(product) {
    var isWallpaper = product.product_type.toLowerCase() === "wallpaper";
    var hasSize = product.options.includes("size");
    var samples = [];

    if (!isWallpaper || !hasSize || !product.variants.length) {
      return samples;
    }

    samples = jQ.grep(product.variants, function (variant) {
      return variant.option_size.toLowerCase().includes("sample");
    });

    return samples;
  }
  // Check Material Variants 
  function checkMaterialVariants(data) {
    // Check query string to see if the results are filtered
      var hasMaterialFilterQueryParam = Globals.queryParams.hasOwnProperty("pf_opt_material");
      var materialCollection = jQ("[data-material-collection]").attr("data-material-collection");
    
      if (materialCollection) {
        materialCollection = [jQ("[data-material-collection]").attr("data-material-collection")];
      }
      var matchingVariants = [];
    
      if (hasMaterialFilterQueryParam || materialCollection ) {
        var selectedMaterials = Globals.queryParams.pf_opt_material  || materialCollection;
          
        for (var k = 0; k < selectedMaterials.length; k++) {
          var selectedMaterial = selectedMaterials[k].toLowerCase();
          // Take the current color filter and find a match in the variant's option_color or metafields.color
          var matchingVariant = $.grep(data.variants, function (item, index) {
            var isSampleVariant = item.title.toLowerCase().includes("sample");
            if(isSampleVariant) { return false; }
  
            var matchesMaterialOption = item.option_material ? item.option_material.toLowerCase().includes(selectedMaterial) : false;
  
            return (matchesMaterialOption);
          });
          // Merge any matches into the matchingVariants array
          $.merge(matchingVariants, matchingVariant);
        }
      }else {
        matchingVariants = data.variants;
      }
    return matchingVariants;
  }
  // Build Swatch
  function buildSwatch(data, _this) {
    
    var itemSwatchHtml = "";
    var itemSwatchHoverImagesHtml = "";
    var sampleData = getSampleButtonData(data);
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (
          option_name.indexOf("color") != -1 ||
          option_name.indexOf("colour") != -1
        ) {
          var option_index = index;
          var values = [];
          var matchedVariants = checkMaterialVariants(data);
          var customSampleData = getCustomSampleButtonData(matchedVariants);
          matchedVariants.forEach(function (variant) {
            var value = variant.merged_options[option_index].split(":")[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var indexOfVariant = data.variants.indexOf(variant);
              var currentVariantIndext = data.current_variant_index;
              var isActiveSwatch = data.variants.indexOf(variant) === data.current_variant_index;
              var variantImage = Utils.optimizeImage(variant.image, "400x");
              var variantImage2 = "";
              var variantSampleData = customSampleData ? JSON.stringify(customSampleData[colorValueSlugify]) : "";

              var found = false;
              data.images_info.forEach(function (image) {
                if (found) {
                  if (variantImage2 == "") variantImage2 = image.src;
                }
                if (image.src == variant.image) {
                  found = true;
                }
              });

              // From upgrade, Utils.optimizeImage might be useful?
              // var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace("boost-pfs.js", colorValueSlugify + ".png"), "50x");

              var swatchItem =
                '<a class="color-swatch color-swatch--filter color-swatch--{{colorValueSlugify}} {{swatchClass}}' +
                (isActiveSwatch ? " is-active" : "") +
                '"' +
                'data-product-id="' + data.id + '"' +
                'data-variant-color="{{colorValueSlugify}}" ' +
                'data-variant-url="{{itemUrl}}?variant={{variantId}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'data-variant-image-2="{{variantImage2}}" ' +
                "data-variant-sample-data='{{variantSampleData}}' " +
                'title="' + value + '" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                "</a>";

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? "color-swatch--with-image" : "");
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variant.image);
              swatchItem = swatchItem.replace(/{{variantImage2}}/g, variantImage2);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, variantImage.replace("https:", ""));
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split("-").pop());
              swatchItem = swatchItem.replace(/{{variantSampleData}}/g, variantSampleData);

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        // Add active class to first swatch item
        swatchItems[0].replace("color-swatch", "color-swatch is-active");
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join("") + "</div>";
        itemSwatchHoverImagesHtml = swatchHoverImages.join("");
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml,
    };
  }

  function buildBgSet(image) {
    var html = "";
    if (typeof image !== "undefined" && image.hasOwnProperty("src")) {
      var aspectRatio = image.width / image.height;
      if (image.width <= 180)
        html += Utils.optimizeImage(image["src"], "180x") + " 180w " + Math.round(180 / aspectRatio) + "h,";
      if (image.width > 180)
        html += Utils.optimizeImage(image["src"], "180x") + " 180w " + Math.round(180 / aspectRatio) + "h,";
      if (image.width > 360)
        html += Utils.optimizeImage(image["src"], "360x") + " 360w " + Math.round(360 / aspectRatio) + "h,";
      if (image.width > 540)
        html += Utils.optimizeImage(image["src"], "540x") + " 540w " + Math.round(540 / aspectRatio) + "h,";
      if (image.width > 720)
        html += Utils.optimizeImage(image["src"], "720x") + " 720w " + Math.round(720 / aspectRatio) + "h,";
      if (image.width > 900)
        html += Utils.optimizeImage(image["src"], "900x") + " 900w " + Math.round(900 / aspectRatio) + "h,";
      if (image.width > 1080)
        html += Utils.optimizeImage(image["src"], "1080x") + " 1080w " + Math.round(1080 / aspectRatio) + "h,";
      if (image.width > 1296)
        html += Utils.optimizeImage(image["src"], "1296x") + " 1296w " + Math.round(1296 / aspectRatio) + "h,";
      if (image.width > 1512)
        html += Utils.optimizeImage(image["src"], "1512x") + " 1512w " + Math.round(1512 / aspectRatio) + "h,";
      if (image.width > 1728)
        html += Utils.optimizeImage(image["src"], "1728x") + " 1728w " + Math.round(1728 / aspectRatio) + "h,";
    }
    return html;
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = "";
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (
      //Upgrade only has "totalPage > 1"
      //Settings.getSettingValue("general.paginationType") == "default" &&
      totalPage > 1
    ) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return "";
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  function updateSwatch(swatch) {
    var $swatch = $(swatch)
    var $swatchParent = $swatch.closest(".grid-product__colors");
    var $product = $swatch.prev('a.grid-product__link')
    var $link = jQ("[data-id='" + $swatch.data("product-id") + "'] .grid-product__link ");
    var $img1 = jQ("[data-id='" + $swatch.data("product-id") + "'] .grid-product__image");
    var $img2 = jQ("[data-id='" + $swatch.data("product-id") + "'] .grid-product__secondary-image");
    var variantUrl = $swatch.data("variant-url");
    var image1 = $swatch.data("variant-image");
    var image2 = $swatch.data("variant-image-2");
    var variantSampleDataString = $swatch.attr("data-variant-sample-data");
    var swatchUrl = $swatch.attr('data-variant-url')

    // Update product URL
    $product.attr('href', swatchUrl)

    $swatchParent.find(".is-active").removeClass("is-active");
    $swatch.addClass("is-active");

    // If there's sample data for this variant, update the sample button
    // TODO: hide button for colors w/o a sample
    // Update multiple buttons for multiple materials
    if (variantSampleDataString.length) {
      var variantSampleData = JSON.parse(variantSampleDataString);
      var $sampleButton = $link.find("[data-order-sample]");
      $sampleButton.attr("data-order-sample", variantSampleData[0].id);
    }

    // Update link and image attributes
    $link.attr("href", variantUrl);
    $img1.data("srcset", image1);
    $img1.attr("srcset", image1);
    $img2.data("bgset", image2);
    $img2.css("background-image", 'url("' + image2 + '")');
  }

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // Code for #57249
    jQ(".color-swatch.color-swatch--filter").click(function (e) {
      var $currentTarget = jQ(e.currentTarget);

      updateSwatch($currentTarget)
    });
    // Code for #57249
  };

  /* buildAdditionalElements */
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    // Build total products text
    var totalProductText = "";
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product
      );
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProductText);

    // Build filter button text on mobile
    var numSelectedFilter = jQ(
      ".boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label"
    ).length;
    if (numSelectedFilter) {
      jQ(".js-drawer-open-collection-filters").addClass("btn--tertiary-active");
      jQ(".js-drawer-open-collection-filters > span").html(
        boostPFSConfig.label.filter + " (" + numSelectedFilter + ")"
      );
    } else {
      jQ(".js-drawer-open-collection-filters").removeClass(
        "btn--tertiary-active"
      );
      jQ(".js-drawer-open-collection-filters > span").html(
        boostPFSConfig.label.filter
      );
    }

    // Call theme init function
    // wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function () {
      if (typeof theme !== null && window.theme) {
        // Upgrade has this commented out:
        // theme.collectionTemplate.reinit();
        AOS.refreshHard();

        // Upgrade has this commented out:
        // Setup page transition classes
        // if (typeof theme.pageTransitions == "function") theme.pageTransitions();

        // Reload quick shop buttons
        theme.initQuickShop(true);

        // Reload products inside each quick shop
        if (typeof sections !== null && sections)
          sections.register("product-template", theme.Product);
        if (window.$ && typeof $ == "function") {
          $(window).off("popstate");
        }
      }

      // Build quick view modals
      var isReinitQuickview =
        !isFirstLoad ||
        Utils.isSearchPage() ||
        Globals.queryParams.hasOwnProperty("_");
      if (
        !Utils.isMobile() &&
        boostPFSConfig.custom.quick_shop_enable &&
        isReinitQuickview
      ) {
        jQ(".boost-pfs-quick-shop-modal-container").html("");
        if (data.products.length > 0) {
          data.products.forEach(function (product) {
            var quickUrl =
              Utils.buildProductItemUrl(product) + "?view=boost-pfs-quickview";
            if (
              product.product_type &&
              product.product_type.toLowerCase() === "custom wallpaper"
            ) {
              return;
            }
            jQ.ajax({
              url: quickUrl,
              success: function (result) {
                numberQuickViewModalLoaded++;
                jQ(".boost-pfs-quick-shop-modal-container").append(result);
                if (numberQuickViewModalLoaded == data.products.length) {
                  // theme.collectionTemplate.reinit()
                  AOS.refreshHard();

                  // Setup page transition classes
                  if (typeof theme.pageTransitions == "function")
                    theme.pageTransitions();

                  // Reload quick shop buttons
                  theme.initQuickShop(true);

                  theme.collapsibles.init();

                  // Reload products inside each quick shop
                  if (typeof sections !== null && sections)
                    sections.register("product-template", theme.Product);
                  numberQuickViewModalLoaded = 0;
                  jQ(".quick-product__btn").removeClass("bc-hide");
                }
              },
            });
          });
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // Upgrade has this commented out:
      // if (Utils.isInfiniteLoadingPaginationType() || Utils.isLoadMorePaginationType()) {
      //   jQ("body").find("div.collection-filter").removeClass("collection-filter");
      // }

      jQ(".js-drawer-open-collection-filters").on("click", function () {
        jQ("." + Class.filterOption).each(function () {
          var showMoreType = jQ(this).data("show-more-type");
          if (showMoreType && jQ(this).data("display-type") != "range") {
            self.buildFilterShowMore(
              jQ(this).find("." + Class.filterBlockContent),
              showMoreType
            );
          }
        });
      });
    });
  };
  // Upgrade has this added:
  theme.preloadProductModal = function (handle, $btn) {
    var $holder = $("#QuickShopHolder-" + handle);
    var url = theme.routes.home + "products/" + handle + "?view=modal";
    $holder.load(
      url + " .product-section[data-product-handle=" + handle + "]",
      function () {
        sections.register("product-template", theme.Product, $holder);
        $btn.removeClass("quick-product__btn--not-ready");
        AOS.refreshHard();
      }
    );
  };
})();
